import { useMemo } from 'react'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { productColumns } from './ProductFields'

const ListProduct = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()

  const options = useMemo(
    () => ({
      objectType: 'products',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le produit',
          field: 'name'
        }
      },
      isFilter: true,
      columns: productColumns
    }),
    [userRight, user.company_id]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'products',
      title: 'Produits',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListProduct
